












import { Component, Vue } from 'vue-property-decorator'
import HelloWorld from '@/components/organisms/HelloWorld.vue'
import Alert from '@/components/atoms/Alert.vue'
import ProductOverview from '@/components/organisms/ProductOverview.vue'
import MainNavigation from '@/components/molecules/MainNavigation.vue' // @ is an alias to /src

@Component({
  components: {
    MainNavigation,
    ProductOverview,
    Alert,
    HelloWorld
  }
})
export default class Home extends Vue {}
